import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import * as React from 'react';
import { Images } from '../assets';
import { ContentUpdateProps } from '../interface';
import ClaimContainer from './ClaimContainer';

export interface NotEligibleTokenContainerProps {
  tokenName?: string;
  tokenGatingError?: string;
  content?: ContentUpdateProps;
  showDisconnectButton?: boolean;
  logoUrl?: string;
  showBuyButton?: boolean;
  onClickDisconnectWallet: () => void;
  onClickBuyToken?: () => void;
}

const NotEligibleTokenContainer = ({
  logoUrl,
  showDisconnectButton,
  tokenName,
  tokenGatingError,
  showBuyButton,
  onClickDisconnectWallet,
  onClickBuyToken
}: NotEligibleTokenContainerProps) => {
  return (
    <Box>
      <ClaimContainer
        image={logoUrl || Images.MOJITO_LOGO}
        title="Something went wrong."
        description={tokenGatingError || `We can't find a ${tokenName} collection in this wallet.`}
      />
      <Stack
        direction="column"
        gap="16px"
        sx={{
          marginTop: '20px'
        }}
      >
        {showBuyButton && (
          <Button
            sx={{
              width: '100%'
            }}
            onClick={() => onClickBuyToken?.()}
          >
            {`Buy the ${tokenName}`}
          </Button>
        )}
        <Button
          sx={{
            width: '100%'
          }}
          onClick={onClickDisconnectWallet}
        >
          {tokenGatingError?.includes('window is closed') || tokenGatingError?.includes('your interest')
            ? 'Close this window'
            : 'Connect a Different Wallet'}
        </Button>
        {showDisconnectButton && (
          <Button
            sx={{
              width: '100%'
            }}
            onClick={onClickDisconnectWallet}
          >
            Disconnect Wallet
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default NotEligibleTokenContainer;
